export function isNullOrUndefined<T>(target: T | null | undefined) : target is T {
  return target === undefined || target === null;
}

export function isNotNullOrUndefined<T>(target: T | null | undefined) : target is T {
  return !isNullOrUndefined(target)
}

export function capitalize(val: string) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

export const isNotBlank = (text?: string) => !!text;
export const isBlank = (text?: string) => !isNotBlank(text);